<template>
  <v-container class="d-flex h-100 w-100">
    <v-row class="align-center justify-center">
      <v-col cols="3" class="d-flex justify-center align-center">
        <v-progress-circular indeterminate :size="117" :width="12" />
      </v-col>
    </v-row>
  </v-container>
</template>
